import React from "react";
import Announcement from "./Announcement";
import Community from "./Community";
import Event from "./Event";
import People from "./People";
import SlideHeader from "./header/TopHeader";
import { Loading } from "../../../../../utils/helpers/constants";
import Header from "../../../../../components/header/HeaderUser";
import Footer from "../../../../../components/header/Footer";

export default function Home({
  announcements,
  communities,
  events,
  people,
  loading,
  communityLoading,
  peopleLoading,
}) {
  const dataLoading =
    loading === Loading ||
    communityLoading === Loading ||
    peopleLoading === Loading;

  return (
    <>
      {dataLoading ? (
        <div>Loading...</div>
      ) : (
        <div>
          <SlideHeader />
          <div className="mx-20">
            <hr />
            <Announcement announcements={announcements} />
            <hr />
            <Community communities={communities} />
            <hr />
            <Event events={events} communities={communities} />
            <hr />
            <People people={people} />
          </div>
          <Footer />
        </div>
      )}
    </>
  );
}
